// eslint-disable-next-line no-unused-vars
import log from "./log";

class PlayVideo {
	constructor() {
		const hoverintent = require("hoverintent");
		$(".hasVideo").unbind();
		setTimeout(() => {
			$(".hasVideo").each(this.parseVideo);
			const videos = document.getElementsByClassName("hasVideo");
			for (const element of videos) {
				hoverintent(element, this.showVideo, this.hideVideo);
			}
		}, 100);
	}

	parseVideo() {
		const $video = $(this).find("video");
		const $imagen = $video.parent().find("img");
		let rutaImagen = $imagen.attr("data-src");
		if (!rutaImagen) {
			rutaImagen = $imagen.attr("src");
		}
		let ruta = rutaImagen.split("/");
		let file = ruta.pop();
		ruta = ruta.join("/");
		file = file.split(".");
		const ext = file.pop();
		const filename = file[0].replace("@2x", "");
		let finalRuta = `${ruta}/${filename}`;
		if (window.isRetinadisplay) {
			finalRuta += "@2x";
		}
		if (window.hasWebP) {
			finalRuta += ".webp";
		} else {
			finalRuta += `.${ext}`;
		}

		$video.css("background-size", "140px 105px");
		$video.css("background-image", `url("${finalRuta}")`);

		$video.attr("data-playing", "false");
	}

	showVideo() {
		console.log("Running");
		const $video = $(this).find("video");
		if (typeof $video.get(0) !== "undefined") {
			const play = $video.get(0).play();

			if (play !== "undefined") {
				play.then(() => {
					$video.attr("data-playing", "true");
				});
			} else {
				$video.attr("data-playing", "true");
			}
		}
	}

	hideVideo() {
		const $video = $(this).find("video");
		const playing = $video.attr("data-playing");

		if (playing === "true") {
			if (typeof $video.get(0) !== "undefined") {
				$video.get(0).pause();
				$video.attr("data-playing", "false");
			}
		}
	}
}

export default PlayVideo;
